import { render, staticRenderFns } from "./UserDashboardTabs.vue?vue&type=template&id=2cea5109&scoped=true&"
import script from "./UserDashboardTabs.vue?vue&type=script&lang=js&"
export * from "./UserDashboardTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cea5109",
  null
  
)

export default component.exports